module.exports = __webpack_public_path__ + "static/media/replace-vehicle-green.92159576.svg";